import React from 'react';
import { Message, toaster } from 'rsuite';
import { TypeAttributes } from 'rsuite/esm/internals/types';

export function notificationError(error: string) {
  return toaster.push(
    <Message
      type="error"
      header="Error"
      closable
      showIcon
    >
      {error}
    </Message>,
    { placement: 'topCenter', duration: 0 },
  );
}

export function validationError(error: string) {
  return toaster.push(
    <Message
      type="error"
      header="Validation error"
      closable
      showIcon
    >
      <span style={{ whiteSpace: 'pre-line' }}>{error}</span>
    </Message>,
    { placement: 'topCenter', duration: 0 },
  );
}

export function notification(message: string, type: TypeAttributes.Status, duration?: number) {
  return toaster.push(
    <Message type={type} showIcon closable>{message}</Message>,
    { placement: 'topCenter', duration },
  );
}

export function notificationSuccess(success: string, duration: number = 2000) {
  return toaster.push(<Message type="success" showIcon closable>{success}</Message>, { placement: 'topCenter', duration });
}

export function closeAlert(key: string) {
  toaster.remove(key);
}
